export default {
  API_ERROR(state, payload) {
    if (payload) {
      state.apiError = payload;
    }
  },
  SET_SYSTEM_SETTINGS(state, payload) {
    state.stripePublishableKey = payload.stripe_publishable_key; // Old env value VUE_APP_STRIPE_PUBLIC
    state.facebookAppId = payload.facebook_app_id; // Old env value VUE_APP_FACEBOOK_APP_ID
    state.googleApiKey = payload.google_api_key; // Old env value VUE_APP_GOOGLE_API_KEY
    state.pusherApiKey = payload.pusher_api_key; // Old env value VUE_APP_PUSHER_KEY
    state.googleMapsSecret = payload.google_maps_secret; // Old env value VUE_APP_GOOGLE_MAP_SECRET
    state.onesignalAppId = payload.onesignal_app_id; // Old env value VUE_APP_ONESIGNAL_APP_ID
    state.sendbeeDevelopersDocs = payload.sendbee_developers_docs; // Old env value VUE_APP_SENDBEE_DEVELOPER_DOCS
    state.pusherAuthEndpoint = payload.pusher_authentication_endpoint;
    state.webApiRoot = payload.web_api_root;
    state.contactFilterLimits.maxNumberOfBlocks = payload.contact_filter_limits.max_number_of_blocks;
    state.contactImportLimits.maxNumberOfContacts = payload.contact_import_limits.max_number_of_contacts;
    state.maxBroadcastNumbers = payload.broadcast.max_number_of_contacts;

    if (payload.pusher_channels && payload.pusher_channels.web) {
      const desktopChannels = {};
      if (payload.pusher_channels.desktop) {
        Object.entries(payload.pusher_channels.desktop).forEach((entry) => {
          const name = `desktop${entry[0].charAt(0).toUpperCase()}${entry[0].slice(1)}`;
          desktopChannels[name] = entry[1];
        });
      }
      state.pusherChannels = { ...payload.pusher_channels.web, ...desktopChannels };
    } else {
      state.pusherChannels = payload.pusher_channels;
    }
  },
  // Will probably stay unused and a candidate for a removal during rewrite
  SET_SYSTEM_MESSAGES(state, payload) {
    // console.log(payload);
  },
  SET_WA_SETTINGS(state, payload) {
    state.waSettings = payload;
  },
  HIDE_ANNOUNCEMENT(state) {
    state.showAnnouncement = false;
  },
  SHOW_ANNOUNCEMENT(state) {
    state.showAnnouncement = true;
  },
  SET_FULL_WINDOW(state, payload) {
    state.fullWindow = payload;
  },
};
